import { Reveal, ChapterLabel } from "./Motion";
import { PhoneShot } from "./PhoneShot";
import { EXPERIENCE } from "../../data/content";

export const Experience = () => (
  <section id="chapter-3" className="bg-cream-deep/50 border-y border-line/60 py-24 sm:py-36">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
      <Reveal className="max-w-2xl">
        <ChapterLabel index="Chapter Three" />
        <h2 className="serif-display mt-8 text-[2rem] sm:text-[2.7rem] lg:text-[3.3rem] font-light text-charcoal leading-[1.1]">
          Inside HEARD.
        </h2>
        <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-sage/30 bg-sage/10 px-3.5 py-1.5 text-[0.65rem] font-medium uppercase tracking-[0.18em] text-sage-deep">
          <span className="h-1.5 w-1.5 rounded-full bg-sage-deep" />
          Actual screens from the app
        </span>
      </Reveal>

      <div className="mt-14 space-y-16 sm:space-y-24">
        {EXPERIENCE.map((e, i) => (
          <div key={e.title} className="grid items-center gap-12 lg:gap-20 lg:grid-cols-2">
            <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
              <div className="flex justify-center">
                <PhoneShot src={e.src} alt={`HEARD app — ${e.title}`} float className="w-[216px] sm:w-[248px]" />
              </div>
            </Reveal>
            <Reveal delay={0.1} className={i % 2 === 1 ? "lg:order-1" : ""}>
              <span className="text-xs uppercase tracking-[0.3em] text-sage">{`0${i + 1}`}</span>
              <h3 className="serif-display mt-4 text-3xl sm:text-4xl font-light text-charcoal">{e.title}</h3>
              <p className="mt-5 max-w-md text-lg font-normal sm:font-light leading-[1.85] text-ink/70">{e.body}</p>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);
